import { writable } from 'svelte/store';

// Stores a map of { promotionId: achievementId }
// This allows any component to instantly check "Has the user joined this promo?"
// and "What is the achievement ID to log against?"
export const joinedChallenges = writable({});